import { watch } from 'vue'
import { WeightLossCalculator } from '@/helpers/weightPredictor'
import { useSurveyStore } from './survey'

export { useMainStore } from './main'

/**
 * Initialize cross-store watchers that were previously on the Vuex store instance.
 * Call this after pinia is installed and the app is created.
 */
export function initStoreWatchers() {
	const surveyStore = useSurveyStore()

	watch(
		() => ({
			weightInKg: surveyStore.userWeightInKg,
			heightInCm: surveyStore.userHeightInCm,
			targetWeightInKg: surveyStore.userTargetWeightInKg,
		}),
		(newVal, oldVal) => {
			if (!newVal) {
				return
			}
			const { weightInKg, heightInCm, targetWeightInKg } = newVal
			if (
				oldVal &&
				oldVal.weightInKg === weightInKg &&
				oldVal.heightInCm === heightInCm &&
				oldVal.targetWeightInKg === targetWeightInKg
			) {
				return
			}
			if (weightInKg && heightInCm && targetWeightInKg) {
				const predicts = WeightLossCalculator.predictWeightLoss({
					weight: weightInKg,
					weightGoal: targetWeightInKg,
					height: heightInCm,
				})

				surveyStore.setWeightPredicts(predicts)
				const dateEnd = predicts[predicts.length - 1].targetDate
				surveyStore.updateProperty({ isData: false, value: dateEnd, property: 'dateEnd' })
				surveyStore.updateProperty({ isData: true, value: dateEnd, property: 'dateEnd' })
			}
		},
		{ immediate: true },
	)
}
